module.exports = __webpack_public_path__ + "media/images/athletes/2801-39f36072bdcedac166f85477dab9f1e5.png";